// extracted by mini-css-extract-plugin
module.exports = {"root":"IconEdit_root__3QBb6","pencil":"IconEdit_pencil__37TiK"};